export const BOOK = {
    title: 'From Ledger to Insight',
    subtitle: 'A practical guide to accounting information systems',
    description: 'A clear, practical introduction to how accounting systems capture, protect and report financial data. Written for students, accountants and business owners who want to understand the systems behind the numbers.',
    audience: [
        'Accounting and business students',
        'Accountants moving to new systems',
        'Owners and managers who rely on financial reports'
    ]
}

/*
 * The book's chapters, edited here in code (not in the CMS).
 * To add a chapter PDF, put the file in public/books/ and set `pdf` to its
 * path, for example '/books/chapter-2.pdf'. Set `isAvailable: false` to show
 * a Coming Soon page instead.
 */
export const CHAPTERS: Array<{
    number: number
    slug: string
    title: string
    summary: string
    isAvailable: boolean
    pdf: string | null
}> = [
    {
        number: 1,
        slug: 'chapter-1',
        title: 'What Is an Accounting Information System?',
        summary: 'How raw transactions become reliable information: the six components of an accounting information system, the business cycles it supports, and why internal control sits at its core.',
        isAvailable: true,
        pdf: '/books/chapter-1.pdf'
    },
    {
        number: 2,
        slug: 'chapter-2',
        title: 'Internal Control in a Digital World',
        summary: 'Why controls matter, how the COSO framework organizes them, and the practical safeguards every modern accounting system needs.',
        isAvailable: false,
        pdf: null
    }
]
